import { observer } from "mobx-react-lite";
import React, { Fragment } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import SharedCampaignProvider from "../../../contexts/Advertiser/SharedCampaignContext";
import { SidebarCollapseProvider } from "../../../contexts/SidebarCollapseContext";
import SharePageHeader from "../SharePageHeader";
import BudgetTable from "./CampaignPageParts/BudgetTable";
import CampaignSideBar from "./CampaignPageParts/CampaignSidebar";
import Influencers from "./CampaignPageParts/Influencers";
import AuthenticationPage from "./CampaignPageParts/InfluencersParts/AuthenticationPage";
import ProjectTimeline from "./CampaignPageParts/ProjectTimeline";
import DraftReview from "./CampaignPageParts/DraftReview";
import CampaignReport from "./CampaignPageParts/CampaignReport.jsx";

function AdvertiserNavigateTo({ path }) {
  const { id } = useParams();
  return <Navigate to={`/advertiser/campaign_share/${id}/${path}`} replace />;
}

function AdvertiserRedirectDraftParticipant() {
  const { id, influencer_id } = useParams();
  return (
    <Navigate
      to={`/advertiser/campaign_share/${id}/draft_review/participants/${influencer_id}`}
      replace
    />
  );
}

function AdvertiserRedirectDraftAction() {
  const { id, influencer_id, action_id } = useParams();
  return (
    <Navigate
      to={`/advertiser/campaign_share/${id}/draft_review/participants/${influencer_id}/actions/${action_id}`}
      replace
    />
  );
}

export default observer(function AdvertiserSharedCampaign() {
  const location = useLocation();
  const isAuthenticationPage = location.pathname.includes("/authentication/");

  return (
    <Fragment>
      <SharedCampaignProvider>
        <SidebarCollapseProvider>
          <SharePageHeader />
          {!isAuthenticationPage && <CampaignSideBar />}
          <div
            className="fixed bg-rb-grey dark:bg-rb-dark-mode-background w-screen h-screen"
            style={{ zIndex: -10 }}
          />
          <div className="pt-12">
            <Routes>
              <Route path="influencers" element={<Influencers />} />
              <Route
                path="influencers/campaign_authentications/:campaign_authentication_id/authentication/:authentication_id/*"
                element={<AuthenticationPage />}
              />
              <Route path="influencers/*" element={<Influencers />} />
              <Route path="project_timeline" element={<ProjectTimeline />} />
              <Route
                path="project_timeline/:campaign_scenario_id"
                element={<AdvertiserNavigateTo path="project_timeline" />}
              />
              <Route path="budget_table" element={<BudgetTable />} />
              <Route
                path="budget_table/:campaign_scenario_id"
                element={<AdvertiserNavigateTo path="budget_table" />}
              />
              <Route
                path="draft_review/participants/:influencer_id/actions/:action_id"
                element={<DraftReview />}
              />
              <Route
                path="draft_review/participants/:influencer_id"
                element={<DraftReview />}
              />
              <Route path="draft_review" element={<DraftReview />} />
              <Route
                path="draft_review/:campaign_scenario_id/participants/:influencer_id/actions/:action_id"
                element={<AdvertiserRedirectDraftAction />}
              />
              <Route
                path="draft_review/:campaign_scenario_id/participants/:influencer_id"
                element={<AdvertiserRedirectDraftParticipant />}
              />
              <Route
                path="draft_review/:campaign_scenario_id"
                element={<AdvertiserNavigateTo path="draft_review" />}
              />
              <Route path="campaign_report" element={<CampaignReport />} />
            </Routes>
          </div>
        </SidebarCollapseProvider>
      </SharedCampaignProvider>
    </Fragment>
  );
});
